var map = {
	"./kakao-efj.jpg": 991,
	"./kakao-efp.jpg": 3290,
	"./kakao-etj.jpg": 7034,
	"./kakao-etp.jpg": 4880,
	"./kakao-ifj.jpg": 9460,
	"./kakao-ifp.jpg": 2842,
	"./kakao-itj.jpg": 1575,
	"./kakao-itp.jpg": 6235,
	"./kakao-website.jpg": 7110
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 4955;